// import stringToHTML helper functions
import { stringToHTML } from '../../scripts/stringToHTML.js';

// import section style
import './style.scss';

// import template
const _template = require('./tmpl.html?template').default,
  _template_content = stringToHTML(_template).firstChild;

// Add section to body
document.body.append(_template_content);

// Products toggler actions
const togglers = _template_content.querySelectorAll(
  '.products .togglers > button'
);

// Toggler actions
togglers.forEach((el) => {
  el.addEventListener('click', (e) => {
    // Reset to default
    togglers_reset(togglers);

    // Toggle active
    el.classList.add('active');
  });
});

// Reset to default
function togglers_reset(togglers) {
  togglers.forEach((el) => {
    el.classList.remove('active'); // Remove active class
  });
}
